module.exports = __webpack_public_path__ + "static/img/zhifubao.fb6fa13c.png";